import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Aos from "aos";
import React, { useEffect } from "react";

const Pricing = () => {
    useEffect(() => {
        Aos.init({ duration: 1200, once: true });
    }, []);

    const pricingData = [
        {
            id: 1,
            level: "Daily Rate",
            description: "",
            price: "Starting from $69/Day",
            billing: " ",
            message: "All-Inclusive: Insurance, maintenance, and unlimited mileage",
            extend: "Exclusive Booking: No car-sharing—it's yours for the duration",
            tax: "$200 Refundable Deposit: Pay once, get it back when you return the car",
            return: "Flexible Usage: Extend or return anytime",
            delivery: "24/7 Support: Text us anytime, or call during our 12-hour phone window",

        },
        {
            id: 1,
            level: "Weekly Rate",
            description: " ",
            price: "Starting from $399/Week",
            billing: " ",
            message: "Value Package: Enjoy the same perks at a discounted weekly rate",
            extend: "Hassle-Free: Insurance, maintenance, and unlimited mileage included",
            tax: "$200 Refundable Deposit: One-time deposit for peace of mind",
            return: "Lock It In: Your car is reserved for the entire week",
            delivery: "Always There: 24/7 text support plus phone support when you need it",
        },
    ];

    return (
        <>

            <section className="section pricing-section pricing-page py-3" >
                <div className="section-heading mb-2" data-aos="fade-down">
                    <h2>Pricing</h2>
                </div>

                <div className="why-choose-group">
                    <div className="row px-0 mx-1 justify-content-center">
                        {pricingData?.map((pricing: any, index: number) => {
                            return (
                                <div
                                    className="col-lg-4 col-md-4 col-12"
                                    key={index}
                                >
                                    <div className="price-card price-card-popular m-1">
                                        <div className="price-head">
                                            <div className="price-level price-level-popular">
                                                <h6>{pricing.price}</h6>
                                                <span>{pricing.billing}</span>
                                            </div>
                                            <h4>{pricing.level}</h4>
                                            <p>{pricing.description}</p>

                                        </div>
                                        <div className="price-details">
                                            <ul>
                                                <li className="price-check">
                                                    <span>
                                                        <i className="fa-regular fa-circle-check text-primary" />
                                                    </span>
                                                    {pricing.message}
                                                </li>
                                                <li className="price-check">
                                                    <span>
                                                        <i className="fa-regular fa-circle-check text-primary" />
                                                    </span>
                                                    {pricing.extend}
                                                </li>
                                                <li className="price-check">
                                                    <span>
                                                        <i className="fa-regular fa-circle-check text-primary" />
                                                    </span>
                                                    {pricing.tax}
                                                </li>
                                                <li className="price-uncheck">
                                                    <span>
                                                        <i className="fa-regular fa-circle-check text-primary" />
                                                    </span>
                                                    {pricing.return}
                                                </li>
                                                <li className="price-uncheck">
                                                    <span>
                                                        <i className="fa-regular fa-circle-check text-primary" />
                                                    </span>
                                                    {pricing.delivery}
                                                </li>

                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

            </section>

        </>
    );
};

export default Pricing;
